<!--美育浸润-视频子类-->
<template>
    <div class="guide-ext-container" v-loading="loading">
        <div class="museum-title-container">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">{{itemInfo.itemName}}</div>
                <div class="l-b-museum-title-container">{{itemInfo.itemClassifyName}}</div>
            </div>
            <div class="r-museum-title-container">
                <input class="search-input" type="text" placeholder="请输入关键词" v-model="searchKeyword"/>
                <div class="back-btn-container" @click="backPage">⇦返回</div>
            </div>
        </div>

        <!-- 视频子类卡片 -->
        <div class="classify-card-container">
            <div class="classify-card" v-for="(item,index) in filteredList" :key="index" @click="handleCardClick(item)">
                <div class="card-cover">
                    <img :src="item.imgUrl" :alt="item.itemClassifyName"/>
                </div>
                <div class="card-title" :title="item.itemClassifyName">{{item.itemClassifyName}}</div>
            </div>
            <div class="empty-container" v-if="!loading && filteredList.length===0">
                <dataEmpty title="暂无数据"/>
            </div>
        </div>
    </div>
</template>

<script>
import {infoHumItem} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "beautyClassify",
    components: {dataEmpty},
    data() {
        return {
            loading:false,
            searchKeyword:'',
            itemInfo:{},
            classifyList:[],
        }
    },
    computed: {
        filteredList() {
            const keyword = this.searchKeyword.trim();
            if (!keyword) return this.classifyList;
            return this.classifyList.filter(item => {
                const name = item.itemClassifyName || "";
                return name.includes(keyword);
            });
        }
    },
    props:{
        itemId:{
            type: [String,Number],
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.searchKeyword = '';
            this.queryItemInfo();
        },
    },
    created() {
        this.queryItemInfo();
    },
    mounted(){},
    methods: {
        /*查询主题信息及其子分类*/
        queryItemInfo(){
            if (!this.itemId) return;
            this.loading = true;
            infoHumItem({itemId:this.itemId}).then(res => {
                if (res.data.code===1){
                    this.itemInfo = res.data.data || {};
                    this.classifyList = this.itemInfo.classifyList || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        handleCardClick(item){
            this.$emit('view-video-list', item);
        },
        backPage(){
            this.$emit('back-model-page', 'beautyEdu');
        }
    }
}
</script>

<style scoped>
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 0 28px;
    box-sizing: border-box;
}
.l-museum-title-container{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #0d55a4;
    font-size: 18px;
    line-height: 1.4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.r-museum-title-container{
    width: auto;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}
.back-btn-container{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 搜索框 */
.search-input{
    flex-shrink: 0;
    width: 200px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #ffffff;
}
.search-input:focus{
    border-color: #0d55a4;
}

/* 子类卡片 */
.classify-card-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 20px;
    padding: 10px 28px;
    box-sizing: border-box;
}
.classify-card{
    width: calc(25% - 15px);
    flex-shrink: 0;
    background-color: #ffffff;
    border: 1.5px solid #0d55a4;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.25s ease;
    overflow: hidden;
}
.classify-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.card-cover{
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
}
.card-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.card-title{
    width: 100%;
    height: 46px;
    line-height: 46px;
    padding: 0 12px;
    font-size: 15px;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}
.empty-container{
    width: 100%;
}
</style>
